import { api } from '../../../../lib/api'

export const GET_MERCHANTS_REQUEST = 'GET_MERCHANTS_REQUEST'
export const GET_MERCHANTS_SUCCESS = 'GET_MERCHANTS_SUCCESS'
export const GET_MERCHANTS_FAILED = 'GET_MERCHANTS_FAILED'

export const getMerchants = function (onComplete) {
  return function (dispatch) {
    dispatch({
      type: GET_MERCHANTS_REQUEST
    })
    api.getMerchants().then(getMerchantsResponse => {
      dispatch({
        type: GET_MERCHANTS_SUCCESS,
        payload: getMerchantsResponse
      })
      if (onComplete) onComplete(getMerchantsResponse.data.payload)
    }).catch(error => {
      dispatch({
        type: GET_MERCHANTS_FAILED,
        error
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions/superadmin/merchant/get-merchants.js